/**
 * Component: Newsletter
 * Requires: nothing
 */

 var ed = ed || {};

 ed.newsletter = new function () {
    this.init = function () {
        setupSignup();
    }

    function setupSignup() {
        $('.newsletter-form').each(function () {
            var form = this;
            var inputBtn = $('.newsletter-form__button', form);
            var inputName = $('.newsletter-form__input--name', form);
            var inputEmail = $('.newsletter-form__input--email', form);
            var inputFrequency = $('.newsletter-form__input--frequency', form);
            var elementsToValidate = inputName.add(inputEmail).add(inputFrequency); // Combine elements to collection

            // Observe each field for validation
            elementsToValidate.each(function(index, el) {
                var MutationObserver = window.MutationObserver || window.WebKitMutationObserver;
                var observer = new MutationObserver(function () {
                    validateField(el);
                });
                observer.observe(el, { attributes: true });
            });

            // Special observation for inputFrequency
            inputFrequency.on('change', function() {
                validateField(this);
            });

            // On submit
            inputBtn.click(function (event) {
                event.preventDefault();

                if ($(form).isValid()) {
                    var nodeId = $(form).data('node-id');
                    var listId = $(form).data('list-id');
                    var nameValue = inputName.val();
                    var emailValue = inputEmail.val();
                    var frequenceValue = inputFrequency.length ? inputFrequency.val() : '';

                    var payload = {
                        NodeId: nodeId,
                        ListId: listId,
                        Name: nameValue,
                        Email: emailValue,
                        Frequency: frequenceValue
                    };

                    $.post('/umbraco/api/mailchimpapi/signup', payload, function (data) {
                        if (data.Success) {
                            $(form).addClass('newsletter-form--success');
                        } else {
                            $(form)
                            .removeClass('newsletter-form--success')
                            .addClass('newsletter-form--error');
                        }
                    }).fail(function () {
                        $(form)
                            .removeClass('newsletter-form--success')
                            .addClass('newsletter-form--error');
                    });
                }
                else {
                    // Validate on submit
                    elementsToValidate.each(function(index, el) {
                        validateField(el);
                    });
                }
            });
        });
    }

    function validateField(el){
        var field = $(el);

        if(!field[0].validity.valid) {
            field.closest('.form-group').addClass('invalid');
        }
        else {
            field.closest('.form-group').removeClass('invalid');
        }
    }

    $.fn.isValid = function () {
        return this[0].checkValidity();
    }
};
